import React from "react";
// import EditIcon from "@mui/icons-material/Edit";
// import ClearIcon from "@mui/icons-material/Clear";
// import SweetAlert from "react-bootstrap-sweetalert";
// import Box from "@mui/material/Box";
// import { Formik, Form, Field } from "formik";
// import { toast } from "react-toastify";
import axios from "axios";
import Pagination from "../../Pagination/Pagination";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import { useAppContext } from "../../Lib/ContextLib";
// import html2pdf from "html2pdf.js";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
import EmptyState from "../../Components/EmptyState";
// import socketIO from "socket.io-client";

export default function Bet() {
  const { accessObject } = useAppContext();
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [changeStatus, setChangeStatus] = React.useState();
  const [filteredData, setFilteredData] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [filterEmail, setFilterEmail] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState(0);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  React.useEffect(() => {
    getBranch();
  }, [filterEmail, pageNumber, recordLength, changeStatus]);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getBranch = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/history/get-win-history`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        search: filterEmail,
      })
      .then((response) => {
        setLoader(false);
        console.log("payout=============>", response.data.data);
        if (response?.data?.data?.totalLength > 0) {
          setFilteredData(response.data.data.getHistoryData);
          setTotalLength(response.data.data.totalLength);
        } else {
          setFilteredData([]);
          setTotalLength(0);
        }
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  return (
    <div>
      <div className="content p-3">
        <div className="card">
          <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
            <div className="row align-items-end justify-content-start">
              <div className="col-md-4">
                <label className="small text-muted font-weight-bold mb-1">Search Player Id</label>
                <div className="position-relative">
                  <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                  <input
                    className="form-control premium-search-input"
                    type="text"
                    value={filterEmail}
                    placeholder="Search Player Id..."
                    onChange={(e) => {
                      setPageNumber(1);
                      setRecordLength(10);
                      setFilterEmail(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="card-body"
            id="download-PDF"
            style={{ overflow: "scroll" }}
          >
            <table class="table table-bordered table-striped" id="table-to-xls">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Id</th>
                  <th style={{ textAlign: "center" }}>Date</th>
                  <th style={{ textAlign: "center" }}>Room Id</th>
                  <th style={{ textAlign: "center" }}>Round Id</th>
                  <th style={{ textAlign: "center" }}>Player Id</th>
                  <th style={{ textAlign: "center" }}>Email</th>
                  <th style={{ textAlign: "center" }}>Game No</th>
                  <th style={{ textAlign: "center" }}>Amount</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                </tr>
              </thead>

              {accessObject?.getPayoutList == true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {filteredData.length > 0 ? (
                          <>
                            {filteredData?.map((item, index) => (
                              <tr key={index} style={{ textAlign: "center" }}>
                                <td style={{ textAlign: "center" }}>
                                  {pageNumber === 1
                                    ? index + 1
                                    : index +
                                      1 +
                                      pageNumber * recordLength -
                                      recordLength}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {moment(item.createdAt).format("DD-MM-YYYY")}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item?.data?.roomId
                                    ? item?.data?.roomId
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item?.data?.roundId
                                    ? item?.data?.roundId
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.playerId ? item.playerId : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.email ? item.email : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.gameNo === 0
                                    ? "-"
                                    : item.gameNo === 1
                                    ? "Smash Block"
                                    : item.gameNo === 2
                                    ? "Tic Tac Toe"
                                    : item.gameNo === 3
                                    ? "Block Blast"
                                    : item.gameNo === 4
                                    ? "Word Book"
                                    : item.gameNo === 5
                                    ? "Number Puzzle 2248"
                                    : item.gameNo === 6
                                    ? "Logic Line"
                                    : item.gameNo === 7
                                    ? "Candy Cream"
                                    : item.gameNo === 8
                                    ? "8 ball Pool"
                                    : item.gameNo === 9
                                    ? "Chess Gamebit"
                                    : item.gameNo === 10
                                    ? "Ludo Lion"
                                    : item.gameNo === 11
                                    ? "Poker Pro"
                                    : item.gameNo === 12
                                    ? "Classy Carrom"
                                    : item.gameNo === 13
                                    ? "teenpatti"
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {Math.round(item.amount * 100) / 100}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.status === 0
                                    ? "Pending"
                                    : item.status === 1
                                    ? "Success"
                                    : item.status === 2
                                    ? "Failed"
                                    : "-"}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <EmptyState colSpan={9} message="No Wins Found" subMessage="We couldn't find any win records matching your search criteria." />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={9}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getPayoutList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {accessObject?.getPayoutList == true && filteredData.length != 0 && (
            <Pagination
              updateShowPerpagevalue={updateShowPerpagevalue}
              showPrePage={showPrePage}
              onPaginationChange={onPaginationChange}
              total={filteredData.length}
              paginationTypeApi={true}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              recordLength={recordLength}
              setRecordLength={setRecordLength}
              totalLength={totalLength}
            />
          )}
        </div>
      </div>
    </div>
  );
}
